/** Tool-on-block conversions (pure, DOM-free): hoe and shovel. Axe stripping is not implemented (no stripped log blocks). */
import { AIR, COARSE_DIRT_ID, DIRT_ID, DIRT_PATH_ID, GRASS_ID, MYCELIUM_ID, PODZOL_ID, ROOTED_DIRT_ID } from '../../blocks';

export interface ToolWorld { getBlock(x: number, y: number, z: number): number }

/** Hoe on coarse / rooted dirt becomes plain dirt (vanilla; needs air above, never the bottom face). */
export function hoeConvert(w: ToolWorld, x: number, y: number, z: number, face: number): number {
  if (face === -1) return 0;
  const id = w.getBlock(x, y, z);
  if (id !== COARSE_DIRT_ID && id !== ROOTED_DIRT_ID) return 0;
  return w.getBlock(x, y + 1, z) === AIR ? DIRT_ID : 0;
}

const PATHABLE = new Set([GRASS_ID, DIRT_ID, PODZOL_ID, MYCELIUM_ID, COARSE_DIRT_ID, ROOTED_DIRT_ID]);

/** Shovel right-click: grass / dirt / podzol / mycelium / coarse / rooted dirt becomes a dirt path (air above, not the bottom face). */
export function shovelConvert(w: ToolWorld, x: number, y: number, z: number, face: number): number {
  if (face === -1) return 0;
  if (!PATHABLE.has(w.getBlock(x, y, z))) return 0;
  return w.getBlock(x, y + 1, z) === AIR ? DIRT_PATH_ID : 0;
}
